// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1jfAs","col":"styles_col__FRYPn","fulfillmentStatus":"styles_fulfillmentStatus__3O3do","emailCol":"styles_emailCol__1nZPH"};